import React, {
    useState,
    useEffect,
    useMemo
} from "react";

export default function SectionLegend({

    title,
    items,
    selectedIds,
    activeIds,
    onSelectionChange

}) {

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [position, setPosition] =
        useState({
            top: 96,
            left: 80
        });

    const [dragging, setDragging] =
        useState(false);

    const [dragOffset, setDragOffset] =
        useState({
            x: 0,
            y: 0
        });

    //--------------------------------------------------------
    // Drag handling
    //--------------------------------------------------------

    useEffect(function () {

        function handleMouseMove(e) {

            if (!dragging) {
                return;
            }

            setPosition({
                left:
                    e.clientX - dragOffset.x,

                top:
                    e.clientY - dragOffset.y
            });

        }

        function handleMouseUp() {

            setDragging(false);

        }

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            handleMouseUp
        );

        return function () {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                handleMouseUp
            );

        };

    }, [
        dragging,
        dragOffset
    ]);

    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{

                position:
                    "fixed",

                top:
                    position.top + "px",

                left:
                    position.left + "px",

                padding:
                    "14px 16px",

                background:
                    "rgba(255,255,255,0.94)",

                borderRadius:
                    "0px",

                border:
                    "1px solid rgba(7,28,49,0.10)",

                borderBottom:
                    "2px solid #20afe8",

                boxShadow:
                    "0 8px 24px rgba(7,28,49,0.16)",

                zIndex:
                    60000,

                backdropFilter:
                    "blur(10px)",

                WebkitBackdropFilter:
                    "blur(10px)",

                minWidth:
                    "240px"

            }}
        >

            {/* TITLE / DRAG HANDLE */}

            <div
                onMouseDown={function (e) {

                    setDragging(true);

                    setDragOffset({

                        x:
                            e.clientX - position.left,

                        y:
                            e.clientY - position.top

                    });

                }}
                style={{

                    fontWeight:
                        "600",

                    marginBottom:
                        "12px",

                    fontSize:
                        "14px",

                    color:
                        "#222",

                    cursor:
                        "move",

                    userSelect:
                        "none"

                }}
            >

                {title}

            </div>

            {/* ITEMS */}

            {items.map(function (o) {

                const selected =

                    selectedIds.length === 0
                    || selectedIds.indexOf(o.id) >= 0;

                //------------------------------------------------
                // Currently represented in filtered results
                //------------------------------------------------

                const active =

                    activeIds.indexOf(o.id) >= 0;

                return (

                    <div
                        key={o.id}
                        onClick={function () {

                            let next = [];

                            //----------------------------------------
                            // Currently ALL
                            //----------------------------------------

                            if (selectedIds.length === 0) {

                                next =
                                    items
                                        .map(function (x) {

                                            return x.id;

                                        })
                                        .filter(function (id) {

                                            return id !== o.id;

                                        });

                            }

                            //----------------------------------------
                            // Currently selected
                            //----------------------------------------

                            else if (selected) {

                                next =
                                    selectedIds.filter(function (id) {

                                        return id !== o.id;

                                    });

                                //------------------------------------
                                // None left = ALL
                                //------------------------------------

                                if (next.length === 0) {

                                    next = [];

                                }

                            }

                            //----------------------------------------
                            // Currently deselected
                            //----------------------------------------

                            else {

                                next =
                                    selectedIds.concat([
                                        o.id
                                    ]);

                            }

                            onSelectionChange(
                                next
                            );

                        }}
                        style={{

                            display:
                                "flex",

                            alignItems:
                                "center",

                            marginBottom:
                                "6px",

                            cursor:
                                "pointer",

                            padding:
                                "8px 10px",

                            borderRadius:
                                "0px",

                            border:
                                selected
                                    ? "1px solid rgba(7,28,49,0.06)"
                                    : "1px solid transparent",

                            transition:
                                "all 0.18s ease",

                            background:
                                selected
                                    ? "rgba(7,28,49,0.035)"
                                    : "transparent",

                            //----------------------------------------
                            // Grey out if no matching desks
                            //----------------------------------------

                            opacity:
                                active
                                    ? (selected ? 1 : 0.45)
                                    : 0.22

                        }}
                    >

                        {/* COLOUR SELECTOR */}

                        <div
                            style={{

                                width:
                                    "12px",

                                height:
                                    "12px",

                                borderRadius:
                                    "50%",

                                background:
                                    selected
                                        ? o.color
                                        : "transparent",

                                border:
                                    selected
                                        ? "3px solid " + o.color
                                        : "3px solid rgba(0,0,0,0.18)",

                                boxShadow:
                                    selected
                                        ? "0 0 10px " + o.color
                                        : "none",

                                transition:
                                    "all 0.18s ease",

                                marginRight:
                                    "12px",

                                flexShrink:
                                    0

                            }}
                        />

                        {/* TEXT */}

                        <div
                            style={{

                                fontSize:
                                    "13px",

                                fontWeight:
                                    selected
                                        ? 600
                                        : 500,

                                color:
                                    active
                                        ? "#222"
                                        : "rgba(0,0,0,0.65)"

                            }}
                        >

                            {o.name}

                        </div>

                    </div>

                );

            })}

        </div>

    );

}